export const SESSION_STORAGE_FIRST_VISITED_URL = 'firstVisitedUrl'
export const SESSION_STORAGE_FIRST_VISITED_HREF = 'firstVisitedHref'
